import React, { memo } from 'react';

const AIEditsTestingFlag: React.FC = memo(() => {
  return (
    <div className="inline-flex">
      <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700">Copied for AI Edits</span>
    </div>
  );
});

export default AIEditsTestingFlag;
